import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MessageOutlined } from '@material-ui/icons';

import BodyVisits from '../BodyVisits';
import BodyItem from '../BodyItem';
import locales from '../../../../../locales';
import { ReserveNotification } from '../../../../../types/INotificationsStore';
import { declensionWord, formatNumber } from "../../../../../helpers/helpers";
import { UserLoyaltyInfo } from "../../../../../_FSD/shared/ui/userLoyaltyInfo";

interface ReserveBodyProps {
  notification: ReserveNotification;
}

const useStyles = makeStyles(() => ({
  comment: {
    color: '#aaaaaa',
    fontSize: 12,
  },
  commentIcon: {
    color: '#6ae9c5',
    fontSize: 18,
  },
  amount: {
    color: "#6ae9c5",
    fontSize: 16,
    fontWeight: 500,
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  firstBlock: {
    width: '20%',
  },
  otherBlock: {
    width: '40%',
  }
}));

function ReserveBody(props: ReserveBodyProps) {
  const classes = useStyles();

  const { notification } = props;
  const { payload } = notification;

  const comment = notification.getComment();
  const visitDate = notification.getVisitDate();
  const guestPremiumBonus = notification.getPremiumBonus();
  const guestPremiumBonusBalance = notification.getPremiumBonusBalance();

  return (
    <>
      <Box display="flex" justifyContent='flex-start' mb={2}>
        <BodyItem
          className={classes.firstBlock}
          label={locales.t('notifications.properties.persons')}
          value={('persons' in payload && payload.persons.toString()) || '?'}
          rightIndent={3}
        />
        <BodyItem
          className={classes.otherBlock}
          label={locales.t('notifications.properties.visitDate')}
          value={visitDate && visitDate.format('lll')}
          rightIndent={3}
        />
        <BodyItem
          className={classes.otherBlock}
          label={locales.t('notifications.properties.table')}
          value={notification.getTable() || '?'}
          rightIndent={0}
        />
      </Box>

      {comment && (
        <Box display="flex" mb={2}>
          <Box mr={1} clone>
            <MessageOutlined className={classes.commentIcon} />
          </Box>
          <Box>
            <Typography className={classes.comment}>{comment}</Typography>
          </Box>
        </Box>
      )}

      {"prepay" in payload && !!payload.prepay.amount && (
        <Box display="flex" mb={2} justifyContent="center">
          <Typography className={classes.amount}>
            Депозит {formatNumber(payload.prepay.amount)}{" "}
            {declensionWord(payload.prepay.amount, [
              "рубль",
              "рубля",
              "рублей",
            ])}
          </Typography>
        </Box>
      )}

      {notification.open && (
        <>
          <Box mb={2} clone>
            <div
              style={{
                width: 256,
                height: 1,
                backgroundColor: '#c5c5c5',
                margin: '0 auto',
              }}
            />
          </Box>

          <BodyVisits notification={notification} />
          {Boolean(guestPremiumBonus) && <>
            <Box mb={2} clone>
              <div
                style={{
                  width: 256,
                  height: 1,
                  backgroundColor: '#c5c5c5',
                  margin: '0 auto',
                }}
              />
            </Box>
            <UserLoyaltyInfo type={guestPremiumBonus} bonus={guestPremiumBonusBalance} isNotification />
          </>}
        </>
      )}
    </>
  );
}

export default ReserveBody;
